// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9i-0";
export var orangeButton = "_9i-1";